export default {
  namespaced: true,
  state () {
    return {
      currentSlots: { date: '', slots: [], deviceId: '', deviceName: '' }
    }
  },
  mutations: {
    setCurrentSlots (state, obj) {
      state.currentSlots = obj
    },
    clearCurrentSlots (state) {
      state.currentSlots = { date: '', slots: [], deviceId: '', deviceName: '' }
    }
  },
  actions: {},
  getters: {
    getCurrentSlots (state) {
      return state.currentSlots
    }
  }
}
